module.exports = __webpack_public_path__ + "img/start-4.62387ef3.png";